import { createContext } from "react"

export type SurveyContextType = {
  displayType: "input" | "web" | "print"
}
const SurveyContext = createContext<SurveyContextType>({
  displayType: "web"
})
export default SurveyContext
